import { render } from "./optionalshares.vue?vue&type=template&id=1d7d642a&ts=true"
import script from "./optionalshares.vue?vue&type=script&lang=ts"
export * from "./optionalshares.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__